<script lang="ts">
    import Select from "svelte-select/Select.svelte"
    import { postDBEntry } from "../../../api"
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()
    type Value = string | number | string[] | number[]
    type ValueStorage = {
        value: string | number
        label: string
        created?: boolean
    }

    export let value: Value = "",
        editMode = true,
        onBlur: (event, valueChanged) => void

    const endpointCall = async () => {
        try {
            const response = await postDBEntry("action", {
                operation: "getDifferingCompanyNames",
            })

            const valueStorage: ValueStorage[] = []
            response.data.forEach((item) => {
                valueStorage.push({
                    value: item,
                    label: item,
                })
            })
            return valueStorage
        } catch (e) {
            throw e
        }
    }
    // Set initial default value for multiple select
    let valueStorage: ValueStorage = { value: null, label: null },
        options: ValueStorage[] = [],
        loaded = false,
        rerender = 0

    endpointCall()
        .then((optionsRes) => {
            options = optionsRes
            rerender += 1
            valueStorage = options.find((choice) => choice.value === value)
        })
        .catch(console.error)
        .finally(() => {
            loaded = true
        })

    $: if (loaded && !!valueStorage) {
        const newValue = valueStorage?.value
        if (JSON.stringify(newValue) !== JSON.stringify(value)) value = newValue
    }

    function handleFilter(e: { detail: string | any[] }) {
        if (e.detail.length === 0 && filterText.length > 0) {
            const prev = options.filter((i) => !i.created)
            options = [...prev, { value: filterText, label: filterText, created: true }]
        }
    }

    function handleChange(e) {
        options = options.map((i) => {
            delete i.created
            return i
        })

        onBlur(null, true)
    }

    $: hasValue = !!value
    let listOpen = false
    let filterText = ""
</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
<label
    class="svelte-select-label"
    class:noEditMode="{!editMode}"
>
    {#if editMode}
        <div
            class="selectWrapper"
            class:hasAValue="{hasValue}"
        >
            {#if hasValue}
                <p class:hasValue="{hasValue}">Firma</p>
            {/if}
            {#key rerender}
                <Select
                    items="{options}"
                    inputAttributes="{{ autocomplete: 'on' }}"
                    showChevron="{false}"
                    clearable="{false}"
                    hideEmptyState="{true}"
                    searchable="{true}"
                    bind:value="{valueStorage}"
                    placeholder="Firma"
                    on:clear="{(e) => (valueStorage = valueStorage)}"
                    bind:listOpen="{listOpen}"
                    on:change="{handleChange}"
                    on:filter="{handleFilter}"
                    bind:filterText="{filterText}"
                >
                    <div
                        class="svelte-select-custom-item"
                        slot="item"
                        let:item
                    >
                        <div class:isSelected="{item?.value === valueStorage?.value}">
                            {item.created ? "Hinzufügen: " : ""}
                            {item.label}
                        </div>
                    </div>
                </Select>
            {/key}
        </div>
        <button
            class="chevron"
            on:click|preventDefault|stopPropagation="{() => (listOpen = !listOpen)}"
        >
            <img
                src="../../../assets/icons/solar_alt-arrow-down-outline.svg"
                alt="icon"
            /></button
        >
    {:else}
        <div class="no-input">
            {#if valueStorage && hasValue}
                <div class="select-no-input">{valueStorage.label}</div>
            {/if}
        </div>
    {/if}
</label>

<style lang="less">
    .svelte-select-label {
        max-height: 54px;
        min-height: 54px;
    }
    .svelte-select-custom-item {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
    }
    .isSelected {
        background-color: var(--primary-100);
        color: white !important;
    }
</style>
